module.exports = __webpack_public_path__ + "static/media/Arrow1.1eaef669.svg";